import { alpha } from '@mui/material/styles'
import type { SxProps, Theme } from '@mui/material/styles'

/** Thêm / Sửa / Xem — cùng kích thước vùng header, chỉ khác màu nền */
export type ModalHeaderIntent = 'create' | 'edit' | 'view' | 'default'

/** Padding + chiều cao tối thiểu giống nhau cho mọi intent */
export const modalHeaderTitlePaddingSx: SxProps<Theme> = {
  py: { xs: 0.85, sm: 1 },
  px: { xs: 1.5, sm: 1.75 },
  pr: { xs: 1, sm: 1.25 },
  minHeight: 48,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}

/**
 * Nền header theo theme accent (`palette.primary` / warning).
 * Đổi chủ đề → đổi màu header modal.
 */
export function modalHeaderTitleBackgroundSx(intent: ModalHeaderIntent = 'default'): SxProps<Theme> {
  return (theme) => {
    const dark = theme.palette.mode === 'dark'
    const primary = theme.palette.primary.main
    if (intent === 'create') {
      return { bgcolor: dark ? alpha(primary, 0.28) : alpha(primary, 0.14) }
    }
    if (intent === 'edit') {
      const warn = theme.palette.warning.main
      return { bgcolor: dark ? alpha(warn, 0.24) : alpha(warn, 0.16) }
    }
    if (intent === 'view') {
      return { bgcolor: dark ? alpha(primary, 0.2) : alpha(primary, 0.1) }
    }
    // default — nhẹ theo primary (không xám cứng)
    return { bgcolor: dark ? alpha(theme.palette.grey[900], 0.55) : alpha(primary, 0.06) }
  }
}
